/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-props-no-spreading */
import NiceModal, { antdModalV5, useModal } from '@ebay/nice-modal-react';
import { Col, ConfigProvider, Row } from 'antd';
import Modal from 'Components/Modal';
import ModalFooter from 'Components/ModalFooter';
import { FormikProps } from 'formik';
import { useRef, useState } from 'react';
import { Button } from 'semantic-ui-react';

import useCheckHealthSummary from '../../hooks/useCheckHealthSummary';

import Content from './Content';
import styles from './EvaluationModal.less';
import Summary from './Summary';

interface Props {
  doctor: any;
  consult: any;
}

const EvaluationModal = NiceModal.create(({ doctor, consult }: Props) => {
  const modal = useModal();
  const [enableEdit, setEnableEdit] = useState(false);

  const formRef = useRef<FormikProps<any> | null>(null);

  const { isLoading, handleCheckHealthSummary } = useCheckHealthSummary();

  const handleSaveAndRecheck = () => {
    // Logic to save and recheck
    formRef.current?.validateForm().then(errors => {
      if (Object.keys(errors).length === 0) {
        // If no errors, proceed with saving
        formRef.current?.submitForm();
        handleCheckHealthSummary(formRef.current?.values, consult.id, 'Recheck');
        setEnableEdit(false);
      }
    });
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            padding: 0,
          },
        },
      }}>
      <Modal title="AI Evaluation" {...antdModalV5(modal)} width={850} className={styles.container}>
        <Row>
          <Col span={12}>
            <Content />
          </Col>
          <Col span={12}>
            <Summary
              doctor={doctor}
              consult={consult}
              enableEdit={enableEdit}
              setEnableEdit={setEnableEdit}
              formRef={formRef}
            />
          </Col>
        </Row>
        <ModalFooter styles={{ margin: 0 }}>
          {enableEdit ? (
            <Button primary onClick={handleSaveAndRecheck} loading={isLoading}>
              Save & Recheck
            </Button>
          ) : (
            <Button primary onClick={() => modal.hide()}>
              Done
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </ConfigProvider>
  );
});

export default EvaluationModal;
